export default (values, value) => /^[0-9]\d*$/.test(value);
